const CLOSED_TAB_CHECK_INTERVAL_MS = 5000

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName

  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export const openBlobInTab = (tab: Window, blob: Blob): void => {
  const url = URL.createObjectURL(blob)

  tab.location.href = url

  const intervalId = setInterval(() => {
    if (!tab.closed) {
      return
    }

    clearInterval(intervalId)
    URL.revokeObjectURL(url)
  }, CLOSED_TAB_CHECK_INTERVAL_MS)
}
